import React, { useEffect, useState } from "react";
import Cleave from "cleave.js/react";
 // eslint-disable-next-line
import config from "../../../../services/config";

import ImpostoDeRendaService from "../../../../services/impostoRenda-service";
import error from "../autorizacaoGuias/images/archive.png";

const DeclaracaoImpostoDeRenda = (props) => {
  const [loading, setLoading] = useState(false);
  const [didError, setDidError] = useState(false);
  const [errors, setErrors] = useState([]);
  const [cpf, setCpf] = useState("");
  const [carteira, setCarteira] = useState("");
  const [response, setResponse] = useState("");

  useEffect(() => {
    window.parent.postMessage('change', window.location.origin)
  });


  const validateForm = () => {
    const errors = [];
    if (cpf.length === 0) {
      errors.push({ field: "cpf", message: "Preencha seu CPF" });
    } else {
      if (cpf.length !== 11) {
        errors.push({ field: "cpf", message: "Verifique seu CPF" });
      }
    }
    if (carteira.length === 0) {
      errors.push({
        field: "carteira",
        message: "Preencha o número de sua carteira"
      });
    } else {
      if (carteira.length !== 17) {
        errors.push({
          field: "carteira",
          message: "Verifique o número de sua carteira"
        });
      }      
    }
    setErrors(errors);
    return errors.length;
  };

  const onSendForm = async () => {
    if (validateForm()) {
      return;
    }
    setLoading(true);
    const res = await ImpostoDeRendaService.auth(cpf, carteira);
    setLoading(false);
    if (res.status) {
      setResponse(res.html);
    }
    if (res.info === "Dados enviados incompletos.") {
      errors.push({ field: "form", message: "Verifique seus dados" });
    }
    if (res.error) {
      setDidError(true);
    }
    setErrors(errors);
  };

  const renderValidation = field => {
    const error = errors.find(e => e.field === field);
    if (!error) {
      return null;
    }
    return <div className="validation-message">{error.message}</div>;
  };

  const renderError = () => {
    if (didError) {
      return (
        <div className="not-found-wrapper">
          <img src={error} alt="Erro" />
          <h5>Ocorreu um erro</h5>
          <p>
            Um erro ocorreu ao processar sua consulta. Por favor tente
            novamente.
          </p>
          <p>
            Se esta mensagem for recorrente, entre em contato com o suporte.
          </p>
        </div>
      );
    }
    return null;
  };

  const renderLoading = () => {
    if (loading) {
      return (
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      );
    }
  };

  return (
    <section
      className={`consulta-copart txt8 lh-1 ${props.hide ? "hide" : ""}`}
    >
      <h2 className="txt-laranja">
        Informe de Rendimentos para fins de Imposto de Renda
      </h2>
      <p>Esta opção está disponível para clientes de Plano Familiar.</p>
      <h3 className="txt-verde">
        Preencha os dados abaixo e clique em "Buscar":
      </h3>
      <div className="box-passos">
        <div className="linha-form">
          <div>Número do cartão do titular</div>
          <div>
            {" "}
            <Cleave
              type={"ontouchstart" in document.documentElement ? "tel" : "text"}
              id="carteira"
              name="carteira"
              value={carteira}
              options={{
                blocks: [1, 3, 12, 1],
                delimiter: " ",
                numericOnly: true
              }}
              onChange={(e)=>setCarteira(e.target.rawValue)}
            />
            {renderValidation("carteira")}
          </div>
        </div>
        <div className="linha-form">
          <div>CPF do cliente</div>
          <div>
            {" "}
            <Cleave
              type={"ontouchstart" in document.documentElement ? "tel" : "text"}
              id="cpf"
              name="cpf"
              value={cpf}
              options={{
                blocks: [3, 3, 3, 2],
                delimiters: [".", ".", "-"],
                numericOnly: true
              }}
              onChange={(e)=>setCpf(e.target.rawValue)}
            />
            {renderValidation("cpf")}
          </div>
        </div>
        <div className="linha-form">
              <div></div>
        <div>
        <button className="btn" onClick={() => onSendForm()}>
          Buscar
        </button>
        </div>
        </div>
        {renderLoading()}
        <div dangerouslySetInnerHTML={{__html: response}}></div>
        {renderError()}
      </div>
    </section>
  );
};

export default DeclaracaoImpostoDeRenda;
